import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';

export const unAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return toObservable(authService.authInitialized).pipe(
    filter(initialized => initialized),
    take(1),
    map(() => {
      if (!authService.authenticatedUser()) {
        return true;
      }
      router.navigate(['/discover']).finally();
      return false;
    })
  );
};
